import { render, staticRenderFns } from "./replyOrder.vue?vue&type=template&id=a2705f2a&scoped=true&"
import script from "./replyOrder.vue?vue&type=script&lang=js&"
export * from "./replyOrder.vue?vue&type=script&lang=js&"
import style0 from "./replyOrder.vue?vue&type=style&index=0&id=a2705f2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2705f2a",
  null
  
)

export default component.exports